module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader",
    class: 'loader-' + (_vm.size ? _vm.size : 'xs')
  }, [_vm._v(_vm._s(_vm.size))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a89ae86a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoaderIcon.vue
// module id = 259
// module chunks = 2